import React from 'react';
import SliderViewContainer from './SliderViewContainer';
import { DnD_element_type_menu } from '../common/ConstantValues';

const GroupSlider = (props) => {
  const {components, message_index, row_index, id, type} = props
  const { setIndex } = props

  return (
    <SliderViewContainer
      {...props}
      key={id}
      isMultiRow={true}
      activeOverlayMenu={false}
      type={type}
    />
  )
}

export default GroupSlider;